module.exports = __webpack_public_path__ + "img/prompt.ce643e5b.png";